import { Element } from "@siteimprove/alfa-dom";
import { PseudoClassSelector } from "./pseudo-class.js";
const { hasName, isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#only-of-type-pseudo}
 */
export class OnlyOfType extends PseudoClassSelector {
    static of() {
        return new OnlyOfType();
    }
    constructor() {
        super("only-of-type");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        return (element
            .inclusiveSiblings()
            .filter(isElement)
            .filter(hasName(element.name)).size === 1);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (OnlyOfType) {
    OnlyOfType.parse = PseudoClassSelector.parseNonFunctional("only-of-type", OnlyOfType.of);
})(OnlyOfType || (OnlyOfType = {}));
//# sourceMappingURL=only-of-type.js.map